import React, { useState, useEffect } from "react";
import AdminSideMenu from "../../navbar/AdminSideMenu";
import AdminTopMenu from "../../navbar/AdminTopMenu";
import { getPriceList, routeAPI } from "../../../api/api";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import DeletePopup from "../../common/DeletePopup";
import ModifyPriceList from "./components/ModifyPriceList";

const PriceList = () => {
  let { id, name } = useParams();
  let history = useHistory();
  const [updateID, setupdateID] = useState();
  const [priceSet, setPriceSet] = useState();
  const [error, seterror] = useState({
    errarStatus: false,
    errorMessage: "",
    bgcolor: "",
  });

  const [routeAndrateList, setRouteAndrateList] = useState([]);

  const getUserDetails = () => {
    console.log("getUserDetails");
    getPriceList(id).then((res) => {
      console.log("ddd", res.data);
      if (res.data.success === true) {
        setRouteAndrateList(res.data.data);
      } else {
        seterror({
          errarStatus: true,
          errorMessage: res.data.message,
          bgcolor: "alert alert-danger",
        });
      }
    });
  };

  const yesDelete = () => {
    routeAPI("delete_single", updateID).then((res) => {
      if (res.data.success === true) {
        seterror({
          errarStatus: true,
          errorMessage: res.data.message,
          bgcolor: "alert alert-success",
        });
        setTimeout(() => {
          window.location.reload(true);
        }, 1000);
      } else {
        seterror({
          errarStatus: true,
          errorMessage: res.data.message,
          bgcolor: "alert alert-danger",
        });
      }
    });
  };

  useEffect(() => {
    getUserDetails();
  }, []);


  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <AdminSideMenu />

        <div className="layout-page">
          <AdminTopMenu />

          <div className="content-wrapper">
            <div className="container-xxl container-p-y">
              <div className="row">
                <div className="col-lg-12 col-md-4 order-1">
                  {error.errarStatus ? (
                    <div className={error.bgcolor} role="alert">
                      <strong>Alert!</strong> {error.errorMessage}
                      <button
                        type="button"
                        className="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  ) : null}

                  <div className="">
                    <div className="card">
                      <h5 className="card-header ">
                        Price list <span className="text-success">{name}</span>
                        <span className="demo-inline-spacing float-right ">
                          <span
                            onClick={() => history.goBack()}
                            className="btn btn-primary me-1"
                          >
                            <FontAwesomeIcon icon={faArrowLeft} /> Go Back
                          </span>
                        </span>
                      </h5>
                      <div
                        style={{ minHeight: "500px" }}
                        className="table-responsive text-nowrap"
                      >
                        <table className="table">
                          <thead>
                            <tr>
                              <th> Country Name </th>
                              <th> Buying Price </th>
                              <th> Route Name </th>
                              <th>Status</th>
                              <th>created</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody className="table-border-bottom-0">
                            {routeAndrateList.map((items, i) => (
                              <tr key={i}>
                                <td>
                                  <span className="text-primary">
                                    {items.country_name}({items.country_code})
                                  </span>
                                </td>

                                <td>
                                  <span className="text-primary">
                                    {items.buy_price}
                                  </span>
                                </td>
                                <td>
                                  <span className="text-primary">
                                    {items.route_name}
                                  </span>
                                </td>

                                <td>
                                  {items.status === 1 ? (
                                    <span className="badge bg-label-success me-1">
                                      Active
                                    </span>
                                  ) : (
                                    <span className="badge bg-label-danger me-1">
                                      Inactive
                                    </span>
                                  )}
                                </td>
                                <td>{items.created}</td>
                                <td>
                                  <span
                                    role="button"
                                    className="badge bg-danger mr-2"
                                    data-target="#delete"
                                    data-toggle="modal"
                                    onClick={() => setupdateID(items.id)}
                                  >
                                    <FontAwesomeIcon icon={faTrash} /> Delete
                                  </span>
                                  <span
                                    role="button"
                                    className="badge bg-primary mr-2"
                                    data-target="#modifyPrice"
                                    data-toggle="modal"
                                    onClick={() => setPriceSet({
                                      id: items.id,
                                      name: items.country_name,
                                      oldPrice:items.buy_price
                                    })}
                                  >
                                    <FontAwesomeIcon icon={faEdit} /> Update Price
                                  </span>
                                </td>
                               
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DeletePopup yesDelete={yesDelete} />
     {priceSet &&  <ModifyPriceList priceSet={priceSet}  /> }
    </div>
  );
};

export default PriceList;
